import { gql } from '@apollo/client';

export const DELETE_GROUP = gql`
  mutation deleteGroup($id: ID!) {
    group: deleteGroup(id: $id) {
      id
    }
  }
`;
